import { type ParameterID, type CoreProduct } from '@flecto/types'

import { useStoreProductAvailabilityList } from '../../hooks/useStoreProductAvailabilityList'
import { CardProduct } from '../CardProduct/CardProduct'
import { Carousel, type CarouselProps } from '../Carousel/Carousel'

export type CarouselProductsProps = CarouselProps & {
  products?: CoreProduct[]
  excludeProducts?: ParameterID[]
}

export function CarouselProducts({
  products,
  excludeProducts = [],
  ...props
}: CarouselProductsProps) {
  const { data: productsWithAvailability, isLoading } =
    useStoreProductAvailabilityList({
      products: products?.filter((i) => !excludeProducts?.includes(i.id)),
    })

  if ((productsWithAvailability?.length ?? 0) <= 0) {
    return
  }

  return (
    <Carousel {...props}>
      {productsWithAvailability?.map((product) => (
        <Carousel.Slide key={product.id}>
          <CardProduct product={product} isLoadingAvailability={isLoading} />
        </Carousel.Slide>
      ))}
    </Carousel>
  )
}
